import React, { useRef, useCallback } from 'react';



// Maps legacy/Lordicon names to valid Material Symbols
const ICON_MAP = {
    'cross': 'close',
    'bell': 'notifications',
    'apps': 'grid_view',
    'plus': 'add',
    'approve': 'check_circle',
    'approved': 'verified',
    'history': 'history',
    'history_2': 'history_2',
    'wallet': 'account_balance_wallet',
    'shopping-bag': 'local_mall',
    'link': 'link',
    'link_2': 'link_2',
    'sync': 'sync',
    'avatar': 'person',
    'home': 'home',
    'cash': 'payments',
    'bolt': 'bolt',
    'suitcase': 'work',
    'sort': 'swap_vert',
    'filter': 'filter_alt',
    'kanban': 'view_kanban',
    'headphones': 'headset',
    'warning': 'warning',
    'folder': 'folder',
    'settings-tune': 'tune',
    'bar-chart': 'bar_chart',
    'academy': 'school',
    'search': 'search',
    'delete': 'delete',
    'edit': 'edit',
    'feedback': 'feedback',
    'chat': 'chat',
    'phone-ring': 'phone',
    'assessment': 'assessment',
    'calendar': 'calendar_today',
    'pin': 'pin_drop',
    'book': 'menu_book',
    'visibility': 'visibility',
    'lock': 'lock',
    'share': 'share',
    'play': 'play_arrow',
    'pause': 'pause',
    'bookmark': 'star',
    'drop-down': 'keyboard_arrow_down',
    'drop-up': 'keyboard_arrow_up',
    'forward': 'arrow_forward',
    'fullscreen': 'fullscreen',
    'fullscreen_exit': 'fullscreen_exit',
    'track_changes': 'track_changes',
    'report_problem': 'report_problem',
    // Aliases
    'dashboard': 'dashboard',
    'insights': 'insights',
    'groups': 'groups',
    'terminal': 'terminal',
    'app-grid': 'grid_view',
    'applauncher': 'apps',
    'business-chat': 'forum',
    'hub': 'hub',
    'badge': 'badge',
    'admin_panel_settings': 'admin_panel_settings',
    'money-prize': 'monetization_on',
    'navigation-arrow': 'navigation',
    'share-chat': 'screen_share',
    'hubspot': 'hub',
    'google-drive': 'add_to_drive',
    'open_in_new': 'open_in_new',
    'local_mall': 'local_mall',
    'unfold_more': 'unfold_more',
    'format_list_bulleted': 'format_list_bulleted',
    'search_off': 'search_off',
    'timer': 'timer',
    'menu': 'menu',
    'list': 'list',
    'numbers': 'numbers',
    'more_horiz': 'more_horiz',
    'description': 'description',
    'chevron_left': 'chevron_left',
    'chevron_right': 'chevron_right',
    'expand_more': 'expand_more',
    'keyboard_double_arrow_right': 'keyboard_double_arrow_right',
    'open_in_full': 'open_in_full',
    'view_column': 'view_column',
    'save': 'save',
    'person': 'person',
    'payments': 'payments',
    'deals': 'payments',
    'deal': 'payments',
    'trending_up': 'bar_chart',
    'analytics': 'bar_chart',
    'verified_user': 'verified',
    'group': 'groups',
    'academic_cap': 'school',
    'automation': 'flash_on',
    'settings_applications': 'settings',
    'group_add': 'person_add',
    'monitoring': 'view_kanban',
    'account_tree': 'sync',
    'support_agent': 'headset',
    'quality_dashboard': 'dashboard',
    'code': 'code',
    'database': 'folder',
    'auto_awesome': 'auto_awesome',
    'notifications_none': 'notifications',
    'command': 'apps',
    'clear': 'close',
    'cancel': 'close',
    'check': 'check',
    'done': 'check',
    'filter_list': 'filter_alt',
    'mail': 'mail',
    'email': 'mail',
    'gchat': 'chat',
    'comment': 'feedback',
    'forum': 'forum',
    'call': 'phone',
    'billing': 'payments',
    'receipt': 'receipt_long',
    'inventory_2': 'inventory_2',
    'shopping_cart': 'shopping_cart',
    'refresh': 'sync',
    'error': 'error',
    'assignment': 'assignment',
    'event': 'calendar_today',
    'apartment': 'apartment',
    'locked': 'lock',
    'security': 'lock',
    'my_location': 'pin_drop',
    'handshake': 'handshake',
    'business': 'business',
    'info': 'info',
    'sparkles': 'auto_awesome',
    'yoda': 'owl',
    'mathematics': 'calculate',
    'math': 'calculate',
    'formula': 'functions',
    'google_chat': 'chat',
    'paste': 'content_paste',
    'content_paste': 'content_paste'
};

const ObliqueIcon = ({ 
    name, 
    size = 22, 
    isActive = false, 
    color = 'currentColor', 
    className = '',
    style = {},
    filled = false,
    animation,
    strokeScale = 1,
    weight = 400,
    interactive,
    ...props 
}) => {
    const ref = useRef(null);

    const rawName = String(name || '').split('/').pop().replace('.json', '');
    const materialName = ICON_MAP[rawName] || rawName || 'help_outline';

    const isFilled = isActive || filled;
    const resolvedWeight = Math.min(700, Math.max(100, Math.round(weight * (strokeScale || 1))));

    return (
        <span 
            ref={ref}
            className={`material-symbols-rounded ${className}`}
            style={{
                fontSize: `${size}px`,
                color: color,
                fontVariationSettings: `'FILL' ${isFilled ? 1 : 0}, 'wght' ${resolvedWeight}, 'GRAD' 0, 'opsz' 24`,
                userSelect: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                lineHeight: 1,
                cursor: 'inherit',
                transition: 'color 0.2s ease, font-variation-settings 0.3s ease-out, transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)',
                ...style
            }}
            {...props}
        >
            {materialName}
        </span>
    );
};

export default React.memo(ObliqueIcon);
